import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { RideErrorMessage, RideTextField } from '@rimac-seguros/ride-system-components';
import moment from 'moment';

import { ageValidate } from '../../../utils/functions';

const InputBirthdateRide = ({
  label, disabled, value, showError, errorText, onChange, onError, onClick,
}) => {
  const [date, setDate] = useState({
    day: '',
    month: '',
    year: '',
  });

  const getFormatField = (currentValue) => (String(currentValue).length === 1 ? `0${currentValue}` : currentValue);

  useEffect(() => {
    if (value) {
      const auxDate = new Date(value);
      setDate({
        day: getFormatField(auxDate.getDate()),
        month: getFormatField(auxDate.getMonth() + 1),
        year: auxDate.getFullYear(),
      });
    }
  }, [value]);

  const handleOnChange = (name, text) => {
    setDate({
      ...date,
      [name]: text.replace(/\D/, ''),
    });

    switch (name) {
      case 'day':
        if (text.length === 2 || Number(text) >= 4) {
          const element = document.getElementById('inputMonth');
          setTimeout(() => element.focus(), 250);
        }
        break;
      case 'month':
        if (text.length === 2 || Number(text) >= 2) {
          const element = document.getElementById('inputYear');
          setTimeout(() => element.focus(), 250);
        }
        break;
      default:
    }
  };

  const validateField = (year, month, day) => {
    const currentDate = `${year || ''}-${getFormatField(month)}-${getFormatField(day)}`;
    const isValid = moment(currentDate, 'YYYY-MM-DD', true).isValid();
    const { showError: errorAge } = ageValidate(date);
    return isValid && !errorAge;
  };

  const handleBlur = (name, text) => {
    const { day, month, year } = date;
    const fullDate = moment(`${year}-${getFormatField(month)}-${getFormatField(day)}`, 'YYYY-MM-DD').toDate();

    setDate({
      ...date,
      [name]: name !== 'year' ? getFormatField(text) : text,
    });

    onError(!validateField(year, month, day));
    if (validateField(year, month, day)) {
      onChange(fullDate);
    }
  };

  return (
    <div className="input-birthdate-ride">
      {label && <label>{label}</label>}
      <div className="input-birthdate-ride-wrapper">
        <div className="input-birthdate-ride-day">
          <RideTextField
            id="inputDay"
            type="text"
            aria-required
            label=""
            placeholder="Día"
            maxLength={2}
            value={date?.day}
            size="large"
            onChange={(e) => handleOnChange('day', e.target.value)}
            onBlur={(e) => handleBlur('day', e.target.value)}
            onClick={onClick}
            disabled={disabled}
            error={showError}
          />
        </div>

        <div className="input-birthdate-ride-month">
          <RideTextField
            id="inputMonth"
            type="text"
            aria-required
            label=""
            placeholder="Mes"
            maxLength={2}
            value={date?.month}
            size="large"
            onChange={(e) => handleOnChange('month', e.target.value)}
            onBlur={(e) => handleBlur('month', e.target.value)}
            onClick={onClick}
            disabled={disabled}
            error={showError}
          />
        </div>

        <div className="input-birthdate-ride-year">
          <RideTextField
            id="inputYear"
            type="text"
            aria-required
            label=""
            placeholder="Año"
            maxLength={4}
            value={date?.year}
            size="large"
            onChange={(e) => handleOnChange('year', e.target.value)}
            onBlur={(e) => handleBlur('year', e.target.value)}
            onClick={onClick}
            disabled={disabled}
            error={showError}
          />
        </div>
      </div>
      {showError && <RideErrorMessage message={errorText} className="message-error" />}
    </div>
  );
};

InputBirthdateRide.defaultProps = {
  label: '',
  disabled: false,
  errorText: '',
  showError: false,
  value: undefined,
  onClick: () => {},
};

InputBirthdateRide.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.shape({
    day: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string,
  }),
  errorText: PropTypes.string,
  showError: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default InputBirthdateRide;
